<template>
	<section class="row">

		<div class="columns small-12 medium-12 large-12">
			<div class="settings">


				<form id="change_pass" class="pass-form" @submit.prevent="updatePassword">
					<p class="settings__text">Сменить пароль</p>

					<label class="settings__label" v-show="sendCode">
						Код с смс
						<input class="pass-form__field pass-form__field_resp" type="text" v-model="code">
					</label>

					<label class="settings__label" v-show="checkedCode">
						Новый пароль
						<input class="pass-form__field pass-form__field_resp" type="text" v-model="password">
					</label>

					<label class="settings__label" v-show="checkedCode">
						Новый пароль (повтор)
						<input class="pass-form__field pass-form__field_resp" type="text" v-model="confirm_password">
					</label>

					<input type="submit" class="pass-form__btn settings__btn basic-blue-btn" value="Сменить">
				</form>

				<p class="settings__text">Смена аватарки</p>


				<user-avatar :data="user" :set-class="'avatar'"></user-avatar>

				<label class="file-upload">
				Загрузить файл
					<input class="settings__btn file-upload__btn" type="file" @change="changeAvatar($event)">
				</label>
			</div>
		</div>

	</section>
</template>

<script>
	import Attachment from '../common/Attachment'

	export default {
		name: 'Setting',
		computed: {
			userId() {
				return this.$storage.get('user')
			},
			user() {
				return this.$store.state.auth.user
			},
			phone() {
				return this.user.phone
			}
		},
		data() {
			return {
				password: '',
				confirm_password: '',
				code: '',
				sendCode: false,
				checkedCode: false
			}
		},
		methods: {
			updatePassword() {
				if (!this.sendCode) {
					this.$api.post('auth/sms/send-code', {
						_scenario: 'password_reset',
						phone: this.phone
					}).then(() => {
						this.$event.toast('s', 'На Ваш телефон отправлен код подтверждения')
						this.sendCode = true
					})
				} else if (this.sendCode && !this.checkedCode) {
					this.$api.post('auth/sms/check-code', {
						code: this.code,
						phone: this.phone,
						_scenario: "password_reset"
					}).then(() => {
						this.checkedCode = true
					})
				} else {
					this.$api.post('auth/reset-password-by-phone', {
						code: this.code,
						phone: this.phone,
						password: this.password,
						password_confirmation: this.confirm_password
					}).then(() => {
						this.$event.toast('s', 'Пароль успешно изменен')
						this.sendCode = false
						this.checkedCode = false
						this.password = ''
						this.confirm_password = ''
						this.code = ''
					})
				}
			},
			changeAvatar(e) {
				if (e.target.files.length)

					new Attachment('avatar.jpg', e.target.files[0])
						.upload('user', this.userId)
						.then(response => this.$store.commit('auth/setAvatar', response))
			}
		}
	}
</script>

<style scoped>
	input {
		margin-top: 3px;
	}

	.avatar {
		max-width: 150px;
		border-radius: 50%;
		text-align: center;
		display: block;
		margin: 0 auto 10px;
		border: 5px solid #fff;
		color: #fff;
	}
</style>



// WEBPACK FOOTER //
// Setting.vue?ee90762a